import {
  AnswerStateMap,
  FieldDependencyMap,
  FieldStateMap,
  FieldVisibilityMap,
  RequiredFields,
} from '../interfaces';
import { buildDependencyMap } from './buildDependencyMap';
import { calculateNextVisible } from './calculateNextVisible';
import { filterFields } from './filterFields';

export const calculateFields = (
  allFields: FieldStateMap,
  answers: AnswerStateMap,
): {
  visibleFields: FieldVisibilityMap;
  requiredFields: RequiredFields;
  dependencyMap: FieldDependencyMap;
} => {
  let visibleFields: FieldVisibilityMap = {};
  const parentlessFields: FieldVisibilityMap = Object.entries(allFields).reduce(
    (prev, [key, value]) => {
      return {
        ...prev,
        [key]: !value.parentFieldId || answers[key] !== undefined,
      };
    },
    {},
  );

  const requiredFields = Object.keys(
    filterFields(allFields, ({ required }) => required),
  );

  const dependencyMap = buildDependencyMap(allFields);

  const entries = Object.entries(parentlessFields);

  for (let i = 0; i < entries.length; i++) {
    const [key, value] = entries[i];
    visibleFields[key] = value;
  }

  for (let i = 0; i < entries.length; i++) {
    const [key] = entries[i];

    if (answers[key]) {
      visibleFields = {
        ...visibleFields,
        ...calculateNextVisible(
          {
            answers,
            dependencyMap,
            requiredFields,
            errors: {},
            alerts: {},
            fields: allFields,
            visibleFields,
            eventFieldId: undefined,
          },
          { answer: answers[key], currentFieldId: key },
        ),
      };
    }
  }

  return {
    visibleFields,
    requiredFields,
    dependencyMap,
  };
};
